import { useContext, useEffect, useState } from 'react'
import { apiGet, apiPut } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import ReactQuill from 'react-quill'
import useToastContext from 'hooks/useToastContext'
import { useTranslation } from 'react-i18next'
import AuthContext from 'context/AuthContext'
import dayjs from 'dayjs'
import { useNavigate } from 'react-router-dom'
import ErrorMessage from 'components/ErrorMessage'
import OImage from 'components/reusable/OImage'
import noImageFound from '../../assets/images/No-image-found.jpg'

const TermsAndConditions = () => {
  const { t } = useTranslation()
  const Navigate = useNavigate()
  const [content, setContent] = useState('')
  const [bnContent, setBnContent] = useState('')
  const [updateDate, setUpdateDate] = useState()
  const notification = useToastContext()
  const [photo, setPhoto] = useState('')
  const [photoError, setPhotoError] = useState('')
  const { logoutUser, user, updatePageName } = useContext(AuthContext)
  const manager = user?.permission?.find(e => e.manager === 'terms_and_conditions') ?? {}
  const getStaticContent = async () => {
    try {
      const path = apiPath.getStaticContent
      const payload = {
        slug: 'terms-and-conditions'
      }
      const result = await apiGet(path, payload)
      if (result?.status === 200) {
        const response = result?.data?.results
        setUpdateDate(response?.updatedAt)
        setContent(response?.content)
        setBnContent(response?.bnContent)
        setPhoto(response?.image)
        setPhotoError(false)
      }
    } catch (error) {
      console.log('error in get all FAQs list==>>>>', error.message)

      if (error.response.status === 401 || error.response.status === 409) {
        logoutUser()
      }
    }
  }
  const updateStaticContent = async () => {
    try {
      const data = {
        title: 'Terms and Conditions',
        content
      }
      const isValid = checkValid()
      if (!isValid) return
      const formData = new FormData()
      formData.append('title', 'About us')
      formData.append('content', content)
      formData.append('bnContent', bnContent)
      formData.append('photo', photo)
      const path = apiPath.getStaticContent + '?' + 'slug=terms-and-conditions'
      const result = await apiPut(path, formData)
      if (result?.status === 200) {
        // var response = result?.data?.results;
        notification.success(result?.data?.message)
        getStaticContent()
        Navigate('/static')
      }
    } catch (error) {
      console.log('error in get all users list==>>>>', error.message)
    }
  }
  const checkValid = () => {
    let isValid = false
    if (photo) {
      isValid = true
      setPhotoError(false)
    } else {
      isValid = false
      setPhotoError('Please select photo')
      window.scrollTo(0, 0)
    }
    return isValid
  }
  useEffect(() => {
    updatePageName(t('NAV_TERMS_AND_CONDITIONS'))
    getStaticContent()
  }, [])
  return (
    <div>
      <div className='bg-[#F9F9F9]'>
        <div className='px-3 py-4'>
          <div className='bg-white border border-[#E9EDF9] rounded-lg'>
            <div className=' border-b-[#E3E3E3] grid 2xl:grid-cols-3 xl:grid-cols-2 lg:grid lg:grid-cols-1 gap-2 px-4 '>
              <div className='col-span-2 flex flex-wrap  items-center' />
            </div>
            <div className='pl-5 pt-4 flex'>
              <label className='mb-2 block pr-1'>
                <strong>{t('UPLOAD_IMAGE')}</strong>
              </label>
              <input
                type='file'
                name='photo'
                placeholder='Photo '
                className='form-control'
                accept='image/png,image/jpeg,image/jpg'
                onChange={event => setPhoto(event?.target?.files[0])}
              />
            </div>
            {photoError && <ErrorMessage message={photoError} />}
            <div className='pl-5 pt-4 '>
              <OImage
                src={
                  typeof photo === 'object'
                    ? URL.createObjectURL(photo)
                    : photo
                }
                fallbackUrl={noImageFound}
                className={"w-[300px] h-[300px]"}
              />
            </div>
            <div className='p-5'>
              {t('O_ENGLISH_CONTENT')} :
              <ReactQuill value={content} onChange={setContent} />
            </div>
            <div className='p-5 shadow-md'>
              {t('O_BANGLA_CONTENT')} :
              <ReactQuill value={bnContent} onChange={setBnContent} />
            </div>
          </div>
          <p style={{marginTop: "10px", marginLeft:"10px"}}>Last Update:- {dayjs(updateDate).format('llll')}</p>
          <div className='2xl:ml-auto xl:ml-0 lg:pt-0 pt-2'>
            <div className='flex'>
            {(manager?.add ||
                    user?.role==='admin') && (<button
                // type='submit'
                className='bg-LightBlue flex text-sm px-8 ml-3 my-4 py-2 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue whitespace-nowrap'
                onClick={updateStaticContent}
              >
                {t('O_UPDATE')}
              </button>)}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default TermsAndConditions
